import React, { useState } from "react";
import { Modal, Button, Form, Row, Col, Spinner, Alert } from "react-bootstrap";

export default function TryOnModal({
  show,
  onHide,
  imageUrl,
  apiBase,
  customerId,
  sessionId,
  onGenerated,
}) {
  const [mode, setMode] = useState("model");

  const [gender, setGender] = useState("Female");
  const [age, setAge] = useState("25");
  const [skinTone, setSkinTone] = useState("Fair");
  const [bodyPart, setBodyPart] = useState("Neck");

  const [userImage, setUserImage] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const detectBodyPart = (url) => {
    const lower = url.toLowerCase();

    if (lower.includes("ring")) return "Fingers";
    if (lower.includes("bangle")) return "Wrist";
    if (lower.includes("bracelet")) return "Wrist";
    if (lower.includes("earring")) return "Face sideways";
    return "Neck";
  };

  const handleGenerate = async () => {
    setError("");
    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("jewellery_image_url", imageUrl);
      formData.append("mode", mode);
      formData.append("customer_id", customerId);

      if (sessionId) {
        formData.append("session_id", sessionId);
      }

      if (mode === "model") {
        formData.append("gender", gender);
        formData.append("age", age);
        formData.append("skin_tone", skinTone);
        formData.append("body_part", bodyPart || detectBodyPart(imageUrl));
      }

      if (mode === "self") {
        if (!userImage) {
          throw new Error("Please upload a photo");
        }

        formData.append("user_image", userImage);
      }

      const res = await fetch(`${apiBase}/images/try-on/`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (!res.ok) {
        throw data;
      }

      onGenerated(data.image_url);

      onHide();
    } catch (err) {
      console.error(err);
      setError(err.error || err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Jewellery Try On</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <div className="mb-3">
          <img
            src={imageUrl}
            alt=""
            style={{
              width: 220,
              borderRadius: 10,
            }}
          />
        </div>

        <Form.Group className="mb-4">
          <Form.Label style={{ color: "rgb(63, 9, 134)" }}>
            Select Mode
          </Form.Label>

          <Form.Select value={mode} onChange={(e) => setMode(e.target.value)}>
            <option value="model">Try on Model</option>
            <option value="self">Try on Self</option>
          </Form.Select>
        </Form.Group>

        {mode === "model" && (
          <>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "rgb(63, 9, 134)" }}>
                    Gender
                  </Form.Label>

                  <Form.Select
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <option>Male</option>
                    <option>Female</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "rgb(63, 9, 134)" }}>
                    Age
                  </Form.Label>

                  <Form.Control
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                    type="number"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "rgb(63, 9, 134)" }}>
                    Skin Tone
                  </Form.Label>

                  <Form.Select
                    value={skinTone}
                    onChange={(e) => setSkinTone(e.target.value)}
                  >
                    <option>Fair</option>
                    <option>Dusky</option>
                    <option>Dark</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "rgb(63, 9, 134)" }}>
                    Body Part
                  </Form.Label>

                  <Form.Select
                    value={bodyPart}
                    onChange={(e) => setBodyPart(e.target.value)}
                  >
                    <option>Neck</option>
                    <option>Fingers</option>
                    <option>Wrist</option>
                    <option>Face sideways</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </>
        )}

        {mode === "self" && (
          <Form.Group>
            <Form.Label style={{ color: "rgb(63, 9, 134)" }}>
              Upload User Photo
            </Form.Label>

            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => setUserImage(e.target.files[0])}
            />
          </Form.Group>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button onClick={handleGenerate} disabled={loading}>
          {loading ? <Spinner size="sm" /> : "Generate"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
